import { useEffect } from "react";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { TrustStrip, WhatIs, BrandStatement, WhoWeHelp, Method } from "@/components/site/SectionsA";
import { ToolsMarquee } from "@/components/site/ToolsMarquee";
import { Academy, CourseGrid } from "@/components/site/SectionsB";
import { Coaching, Workshops, Corporate } from "@/components/site/SectionsC";
import { About, Testimonials, FreeResources, KnowledgeHub, Faq, FinalCTA } from "@/components/site/SectionsD";
import { Footer } from "@/components/site/Footer";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";

const TITLE = "SuhaniEdge — Practical AI Education & Coaching by Suhani Singh";
const DESC = "SuhaniEdge is an AI education brand founded by Suhani Singh, helping beginners, creators, professionals and entrepreneurs learn Generative AI, AI tools, content creation, automation and digital growth.";

export default function Home() {
  useEffect(() => {
    document.title = TITLE;
    const setMeta = (name, content, attr = "name") => {
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    setMeta("description", DESC);
    setMeta("og:title", TITLE, "property");
    setMeta("og:description", DESC, "property");
    setMeta("og:type", "website", "property");
  }, []);

  return (
    <div className="relative grain">
      <Navbar />
      <main>
        <Hero />
        <TrustStrip />
        <ToolsMarquee />
        <WhatIs />
        <BrandStatement />
        <WhoWeHelp />
        <Method />
        <Academy />
        <CourseGrid />
        <Coaching />
        <div id="corporate" className="scroll-mt-20"><Corporate /></div>
        <Workshops />
        <About />
        <Testimonials />
        <FreeResources />
        <KnowledgeHub />
        <div id="faq" className="scroll-mt-20"><Faq /></div>
        <div id="contact"><FinalCTA /></div>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
